/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `NOT_STARTED` - Not Started
 * * `IN_PROGRESS` - In Progress
 * * `1099_COMPLETE` - 1099 Complete
 * * `MKTPLC_COMPLETE` - Marketplace Complete
 * * `REMOVED` - Removed
 */
export enum ProfileDispositionEnum {
    NOT_STARTED = 'NOT_STARTED',
    IN_PROGRESS = 'IN_PROGRESS',
    _1099_COMPLETE = '1099_COMPLETE',
    MKTPLC_COMPLETE = 'MKTPLC_COMPLETE',
    REMOVED = 'REMOVED',
}
